import { Fragment, useContext } from 'react'
import { getDate, getMonth, getMonthLabels, getYear } from '../../utils/calendar/calendar'
import { useTranslation } from 'next-i18next'
import PropTypes from 'prop-types'

// Context
import { UserContext } from '../../context/UserContext'

// Internal components
import Button from '../Button/Button'
import CalendarCard from '../CalendarCard/CalendarCard'
import CalendarIndicator from '../CalendarIndicator/CalendarIndicator'
import CalendarMonth from '../CalendarMonth/CalendarMonth'

const CalendarPreview = (props) => {
  const { data, team, button } = props
  const items = data?.items?.slice(0, 4)
  const currentDate = data?.today?.date?.split(' ')[0]

  // Context
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  let monthTracker = -1
  let indicatorTracker = false
  const noActiveTeam = !userContext?.userSession?.team

  const checkForMonth = (date) => {
    const month = getMonth(date)
    return month !== monthTracker ? (monthTracker = month) : false
  }

  const checkForIndicator = (date) => {
    const itemDate = getDate(date)
    if (!currentDate) return
    return !indicatorTracker ? (indicatorTracker = itemDate >= getDate(currentDate)) : false
  }
  const checkForWithinBlueprint = (isWithinBlueprint, item) => {
    if (!item?.isMatchDay && item?.type !== 'match') isWithinBlueprint = item?.blueprint?.id !== undefined
    return isWithinBlueprint
  }
  let previousDate
  let isWithinBlueprint = items?.[1]?.blueprint?.section === 'body'

  return (
    <div className="CalendarPreview">
      <div className="CalendarPreview-inner">
        {data?.items && data?.items?.length >= 1 ? (
          <>
            {team.title && <h2 className="CalendarPreview-title">{team.title}</h2>}
            <div className="CalendarPreview-items">
              {items &&
                items.map((item, index) => {
                  const month = checkForMonth(item.date)
                  const indicator = checkForIndicator(item.date)
                  const isSameDay = previousDate === item.date
                  isWithinBlueprint = checkForWithinBlueprint(isWithinBlueprint, item)
                  previousDate = item.date

                  return (
                    <Fragment key={`Calendar-fragment--${index}`}>
                      {(!!month || month === 0) && (
                        <CalendarMonth year={getYear(item.date)} month={month} monthLabels={getMonthLabels(t)} />
                      )}
                      {indicator && <CalendarIndicator scrollToIndicator={false} />}
                      <CalendarCard
                        {...item}
                        placeholder={t('CALENDAR_CARD__BTN_ADDTRAINING')}
                        sameDay={isSameDay}
                        key={`CalendarPreview-item--${index}`}
                        isWithinBlueprint={isWithinBlueprint}
                        preview={true}
                      />
                    </Fragment>
                  )
                })}
            </div>
          </>
        ) : (
          <>
            {noActiveTeam && (
              <div className="CalendarPreview-completed">
                <h2 className="CalendarPreview-completedTitle">{t('CALENDAR_PREVIEW__NOTEAM_TITLE')}</h2>
                <p className="CalendarPreview-completedDescription">{t('CALENDAR_PREVIEW__NOTEAM_DESCRIPTION')}</p>
              </div>
            )}
            {!noActiveTeam && (
              <div className="CalendarPreview-completed">
                <span className="CalendarPreview-completedSeason">
                  {userContext?.userSession?.team?.seasonTitle
                    ? userContext?.userSession?.team?.seasonTitle
                    : t('CALENDAR_PREVIEW__COMPLETED_PREVYEAR')}
                </span>
                <h2 className="CalendarPreview-completedTitle">{t('CALENDAR_PREVIEW__COMPLETED_TITLE')}</h2>
                <p className="CalendarPreview-completedDescription">{t('CALENDAR_PREVIEW__COMPLETED_DESCRIPTION')}</p>
              </div>
            )}
          </>
        )}
        {button && !noActiveTeam && (
          <Button
            link={{ href: button.link }}
            label={t(button.label)}
            icon={{ id: 'icon-chevron-right' }}
            modifiers={['Button--calendarPreview']}
          />
        )}
      </div>
    </div>
  )
}

CalendarPreview.propTypes = {
  team: PropTypes.object,
  button: PropTypes.object,
  data: PropTypes.object,
  completed: PropTypes.object,
  placeholder: PropTypes.object
}

export default CalendarPreview
